import { useState, type InputHTMLAttributes } from 'react';

type Props = Omit<InputHTMLAttributes<HTMLInputElement>, 'value' | 'onChange' | 'type'> & { cents: number; onPriceChange: (cents: number) => void };
/** Keep the text the user is typing; format cents only after leaving the field. */
export function EstimatePriceInput({ cents, onPriceChange, ...props }: Props) {
  const [draft, setDraft] = useState<string | null>(null);
  const formatted = Number.isFinite(cents) ? (cents / 100).toFixed(2) : '';
  return <input {...props} type="text" inputMode="decimal" value={draft ?? formatted}
    onFocus={event => { setDraft(formatted); props.onFocus?.(event); }}
    onBlur={event => { setDraft(null); props.onBlur?.(event); }}
    onChange={event => { const value = event.target.value; setDraft(value); const normalized = value.trim(); onPriceChange(/^-?(?:\d+|\d{1,3}(?:,\d{3})+)(?:\.\d{0,2})?$/.test(normalized) ? Math.round(Number(normalized.replaceAll(',', '')) * 100) : NaN); }} />;
}
